<!-- 佐证材料预览弹窗 -->
<template>
<transition name="slide">
  <div class="materials-preview-shadow" v-show="visible" @mousewheel="watchMouseWheel" @DOMMouseScroll="watchMouseWheel">
    <div class="close-btn" @click="handleClose">
      <i class="el-icon-close"></i>
    </div>
    <div class="download-btn" @click="handleDownload" title="下载">
      <i class="el-icon-download"></i>
    </div>
    <div class="left-btn" @click="handlePrevious" v-if="imgList.length > 1">
      <i class="el-icon-arrow-left"></i>
    </div>
    <div class="right-btn" @click="handleNext" v-if="imgList.length > 1">
      <i class="el-icon-arrow-right"></i>
    </div>
    <div class="function-box">
      <i class="el-icon-zoom-out pointer" @click="handleScale('small')"></i>
      <i class="el-icon-zoom-in pointer" @click="handleScale('big')"></i>
      <i class="pointer" :class="imgOrigin ? 'el-icon-c-scale-to-original' : 'el-icon-full-screen'" @click="imgOrigin = !imgOrigin"></i>
      <i class="el-icon-refresh-left pointer" @click="handleRotate('left')"></i>
      <i class="el-icon-refresh-right pointer" @click="handleRotate('right')"></i>
    </div>
    <div class="img-box">
      <img :src="link" alt="图片加载失败" id="materialImg" :class="{ 'img-origin': !imgOrigin }">
    </div>
  </div>
</transition>
</template>

<script>
export default {
  mounted () {
    this.dom = document.querySelector('#materialImg')
  },
  data () {
    return {
      visible: false,
      imgList: [], // 图片列表 数组元素里必须有link字段，表示图片完整路径
      link: '', // 当前查看的图片的地址
      index: 0, // 当前查看的图片在列表里的索引值
      dom: null,
      imgOrigin: false // 图片是否要按照原始大小呈现(即图片原本有多大，就显示多大)
    }
  },
  methods: {
    open (imgList, index = 0) {
      this.imgList = imgList
      this.index = index === -1 ? 0 : index
      this.link = this.imgList[this.index].link
      this.visible = true
    },
    // 获取图片scale与rotate的值
    getScaleAndRotate () {
      let value = this.dom.style.transform // 拿到的值为scale(1) rotateZ(0deg)
      value = value.replace(/(scale\()|(\) rotateZ)|(deg\))/g, '') // 将scale(1) rotateZ(0deg)提取到只剩 “1(0”
      return {
        scale: value === '' ? 1 : Number(value.split('(')[0]),
        rotateZ: value === '' ? 0 : Number(value.split('(')[1])
      }
    },
    // 监听鼠标滚轮的滚动，以缩放图片
    watchMouseWheel (e) {
      if (e.wheelDelta === undefined) { // 这个属性不存在，说明是火狐浏览器
        if (e.detail === 3) { // 3=滚轮向下滚动，缩小图片
          this.handleScale('small')
        } else { // -3=向上滚动，放大图片
          this.handleScale('big')
        }
      } else {
        if (e.wheelDelta === -120) { // -120=滚轮向下滚动，缩小图片
          this.handleScale('small')
        } else { // 120=向上滚动，放大图片
          this.handleScale('big')
        }
      }
    },
    // 缩放
    handleScale (type) {
      let { scale, rotateZ } = this.getScaleAndRotate()
      if (type === 'big') { // 放大
        scale += 0.05
        this.dom.style.transform = `scale(${scale}) rotateZ(${rotateZ}deg)`
      } else { // 缩小
        if (scale <= 0.1) {
          return
        }
        scale -= 0.05
        this.dom.style.transform = `scale(${scale}) rotateZ(${rotateZ}deg)`
      }
    },
    // 旋转
    handleRotate (type) {
      let { scale, rotateZ } = this.getScaleAndRotate()
      if (type === 'left') {
        rotateZ -= 90
        this.dom.style.transform = `scale(${scale}) rotateZ(${rotateZ}deg)`
      } else {
        rotateZ += 90
        this.dom.style.transform = `scale(${scale}) rotateZ(${rotateZ}deg)`
      }
    },
    handleClose () {
      this.visible = false
    },
    // 下载图片
    handleDownload () {
      window.open(this.link, '_blank')
    },
    handleNext () {
      if (this.index === this.imgList.length - 1) {
        this.$message.warning('已经是最后一张了')
        return
      }
      this.index++
      this.link = this.imgList[this.index].link
    },
    handlePrevious () {
      if (this.index === 0) {
        this.$message.warning('已经是第一张了')
        return
      }
      this.index--
      this.link = this.imgList[this.index].link
    }
  }
}
</script>

<style lang="scss">
.materials-preview-shadow {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2999;
  .close-btn, .download-btn, .left-btn, .right-btn {
    position: absolute;
    z-index: 2998;
    background-color: #606266;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    cursor: pointer;
  }
  .close-btn {
    top: 40px;
    right: 40px;
  }
  .download-btn {
    top: 100px;
    right: 40px;
  }
  .left-btn {
    left: 40px;
    top: 50%;
    transform: translateY(-50%);
  }
  .right-btn {
    right: 40px;
    top: 50%;
    transform: translateY(-50%);
  }
  .function-box {
    width: 240px;
    height: 40px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    background-color: #606266;
    position: absolute;
    bottom: 40px;
    left: 50%;
    z-index: 2998;
    transform: translateX(-50%);
    font-size: 24px;
    color: #fff;
  }
  .img-box {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .img-origin {
    max-width: 100%;
    max-height: 100%;
  }
}
.slide-enter, .slide-leave-to {
  transform: translateY(-100%);
}
.slide-enter-active, .slide-leave-active {
  transition: transform 0.2s;
}
</style>
